import { JSX } from "react";

const OptionalExclusionsDescription = (): JSX.Element => {
  return <>
    <p>
      Project option exclusions are Network Integrity alerts that can be leveraged at the project options level prior to the Adequacy analysis being run and offer an upfront layer of protection against invalid provider data impacting the overall results.
    </p>
    <p>
      Any project option exclusions that are already being excluded at the project level will be denoted as “Excluded” in the count column when viewing <b><i>Network Servicing Providers</i></b> from the view toggle.
    </p>
    <p>
      Project option exclusions can be enabled or disabled on each project by your client services consultant.
    </p>
  </>;
}

export { OptionalExclusionsDescription };